// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
// for development environment
//This is QA branch
export const environment = {
  production: false,
  hmr: false,
  name: 'qa',
  apiPath: '/api',
  pusherKey: '0732f9fe1943b48814d1',
  pusherCluster: 'ap1',
  versionCheckURL: 'https://register-qa.srv.simpliedtech.com/version.json',
  baseUrl: 'https://qa.srv2.simpliedtech.com',
  apiHostName: 'https://qa.srv2.simpliedtech.com',
  apiBaseUrl: 'https://qa.srv2.simpliedtech.com/api',
  sentryDSN: '',
  tracingOrigins: [],
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
